import React from 'react';
import styled from 'styled-components';
import config from 'Config';

const Wrapper = styled.div`
  position: fixed;
  top:0;
  bottom: 0;
  width: 100%;
  left:0;
  margin: 0;

  div {
    background-color: rgba(0,0,0,0.8);
    padding: ${({ theme }) => theme.spacing * 4}px;
    position: absolute;
    bottom: 0;
    max-height: 70vh;
    overflow: auto;
    color: ${({ theme }) => theme.palette.colors.white};
    line-height: 1.4em;
    width: 100%;
  }

  a{
    color: inherit;
  }

  button {
    background-color: ${({ theme }) => theme.palette.colors.black};
    width: 100%;
    color: ${({ theme }) => theme.palette.colors.white};
    border: none;
    padding: ${({ theme }) => theme.spacing * 2}px;
  }
`;

const Component = () => {
  const classes = ['CookiesPolicyAcknowledgment'];
  const [showCookiesPolicy, setShowCookiesPolicy] = React.useState(!window.localStorage.getItem('cookies_consent_given'));

  const linksUrl = config.cookiesPolicyLinkUrl;

  function setConsent() {
    window.localStorage.setItem('cookies_consent_given', Date.now());
    setShowCookiesPolicy(false);
  }
  if (!showCookiesPolicy) return null;

  return (
    <Wrapper className={classes.join(' ')} onClick={setConsent}>
      <div role="presentation" onClick={(e) => e.stopPropagation()}>
        <p>
          To provide you with a better service, we use cookies on our pages. We
          use these cookies to make our site work and to help us improve the site.
        </p>
        <p>
          Necessary cookies enable the core functionality of our site, these
          include security, network management and accessibility. You can disable
          these in your browser, but this could affect the functionality of the
          site.
        </p>
        <p>
          Analytic cookies enable us to improve the website by collecting
          and reporting information. There is lots more information on how we use
          cookies and who we share information with in our&ensp;
          <a href={linksUrl.privacyPolicy} rel="noopener noreferrer" target="_blank">privacy policy</a>
          &ensp;and&ensp;
          <a href={linksUrl.cookiesPolicy} rel="noopener noreferrer" target="_blank">cookies policy</a>
          .
        </p>

        <button onClick={setConsent} type="button">Ok</button>
      </div>
    </Wrapper>
  );
};

Component.displayName = 'CookiesPolicyAcknowledgment';

export default Component;
